import { authApi } from 'api/AuthApi';
import { borrowerApi } from 'api/BorrowerApi';
import { intermediaryApplicationsApi } from 'api/IntermediaryApplicationsApi';

import { getAccountThunk } from './Auth/getAccount';
import { loginThunk } from './Auth/login';
import { logoutThunk } from './Auth/logout';
import { getBorrowerByIDThunk } from './Borrowers/getBorrowerByID';
import { getBorrowerShortInfoThunk } from './Borrowers/getBorrowerShortInfo';
import { saveContractorApplicationThunk } from './saveContractorApplication';
import { updateBorrowerThunk } from './Borrowers/updateBorrower';
import { getBorrowerByTokenThunk } from './Borrowers/getBorrowerByToken';

export const login = loginThunk(authApi);
export const logout = logoutThunk(authApi);
export const getBorrowerShortInfo = getBorrowerShortInfoThunk(borrowerApi);
export const getBorrowerByID = getBorrowerByIDThunk(borrowerApi);
export const updateBorrower = updateBorrowerThunk(borrowerApi);

export const getAccount = getAccountThunk(authApi);
export const saveContractorApplication = saveContractorApplicationThunk(intermediaryApplicationsApi);
export const getBorrowerByToken = getBorrowerByTokenThunk(borrowerApi);
